import React, { Dispatch } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    Collapse,
    Fab,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Stack,
} from '@mui/material';
import { IAppReduxStore } from '../../../redux/store';
import { vars } from '../../../Theme';

import Icon from '@mdi/react';
import { mdiChevronDown, mdiChevronRight, mdiDownload, mdiPlus, mdiTrashCan } from '@mdi/js';
import {
    IUserStamp,
    IUserStamps,
    deleteStamp,
    getStampImage,
    openCreateStampDialog,
} from '../../../redux/user/sliceUserStamps';
import CreateStampDialog from '../Dialogs/CreateStampDialog/CreateStampDialog';

const StampsCategory = ({ stampsCategory }: { stampsCategory: IUserStamps }) => {
    const dispatch: Dispatch<unknown> = useDispatch();
    const [open, setOpen] = React.useState(true);

    const handleToggle = () => {
        setOpen(!open);
    };

    return (
        <>
            <ListItemButton onClick={handleToggle}>
                {open ? (
                    <Icon path={mdiChevronDown} color={vars.font} size={1} />
                ) : (
                    <Icon path={mdiChevronRight} color={vars.font} size={1} />
                )}
                <ListItemText primary={stampsCategory.category} />
            </ListItemButton>

            <Collapse in={open} timeout='auto' unmountOnExit>
                <List component='div' disablePadding>
                    {stampsCategory.stamps.map((stamp: IUserStamp) => (
                        <ListItem
                            key={stamp.id}
                            sx={{ pl: 4, backgroundColor: vars.lightGray }}
                            secondaryAction={
                                <>
                                    <IconButton
                                        edge='end'
                                        onClick={() =>
                                            dispatch(
                                                getStampImage({
                                                    stampId: stamp.id,
                                                    stampName: stamp.name,
                                                    fileExtension: stamp.fileExtension,
                                                }),
                                            )
                                        }
                                    >
                                        <Icon path={mdiDownload} color={vars.font} size={1} />
                                    </IconButton>
                                    <IconButton
                                        edge='end'
                                        onClick={() =>
                                            dispatch(
                                                deleteStamp({
                                                    stampId: stamp.id,
                                                }),
                                            )
                                        }
                                    >
                                        <Icon path={mdiTrashCan} color={vars.font} size={1} />
                                    </IconButton>
                                </>
                            }
                        >
                            <ListItemText primary={stamp.name} />
                        </ListItem>
                    ))}
                </List>
            </Collapse>
        </>
    );
};
/**
 * Component that allows the user to manage their stamps.
 */
export default () => {
    /** Allows reducers on a redux slice to be called. */
    const dispatch: Dispatch<unknown> = useDispatch();

    /** Get relevant values from Redux store. */
    const stamps = useSelector((store: IAppReduxStore) => store.userStamps.stamps);

    return (
        <>
            <CreateStampDialog />
            <Stack
                sx={{
                    justifyContent: 'space-between',
                    width: '100%',
                }}
            >
                <Stack direction='row' sx={{ pb: 1 }}>
                    <Fab
                        color='primary'
                        aria-label='add stamp'
                        size='small'
                        onClick={() => dispatch(openCreateStampDialog())}
                    >
                        <Icon path={mdiPlus} color={vars.white} size={1} />
                    </Fab>
                </Stack>
                {stamps && (
                    <List sx={{ width: '100%', overflow: 'auto', maxHeight: '45vh', pb: 2 }}>
                        {stamps.map(stamp => (
                            <StampsCategory key={stamp.category} stampsCategory={stamp} />
                        ))}
                    </List>
                )}
            </Stack>
        </>
    );
};
